import styled from "styled-components";
import { media } from "../../../../layouts/utils";
import {
  TituloH1 as TituloPrincipal,
  Descricao,
} from "../../../../components/TituloSorriso/styles";

export const Wrapper = styled.div`
  display: flex;
  position: relative;
  height: 450px;
  background: transparent
    linear-gradient(0deg, #000000 0%, #000000 69%, #000000 100%) 0% 0% no-repeat
    padding-box;

  ${media.phone`
    width: 100%;
    height: auto;
  `}

  ${media.smallPhone`
    height: content-fit;
  `}
`;

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  ${media.phone`
    flex-direction: column;
    height: auto;
  `}
`;

export const Content = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  justify-content: center;
  padding: 0 74px 0 84px;
  ${media.phone`
    z-index: 1;
    width: 100%;
    align-items: center;
    padding: 30px;
  `}
`;

export const Background = styled.img`
  \background-image: cover;
  width: 100%;
  height: 450px;
  object-fit: cover;
  ${media.phone`
    display: flex;
    height: 100%;
    top: 0;
  `}
`;

export const TextIntro = styled(Descricao)`
  color: ${(props) => props.cor};
  font-size: 16px;
  line-height: 24px;
  text-align: left;
  ${media.phone`
    margin-top: 15px;
    font-size: 14px;
    line-height: 22px;
    text-align: center;
    padding: 0 12px 10px;
  `}
`;

export const TitleContainer = styled.div`
  ${media.phone`
    width: 100%;
    max-width: 410px;
    margin-top: 0;
    padding-bottom: 24px;
  `}
  display: inline-block;
  padding-bottom: 36px;
`;

export const Title = styled(TituloPrincipal)`
  color: ${(props) => props.cor};
  line-height: 42px;
  padding-top: 10px;
  text-align: left;
  ${media.desktop`
    padding-top: 0;
  `}
  ${media.phone`
    line-height: 32px;
    text-align: center;
  `}
`;

export const ContainerCTA = styled.div`
  ${media.desktop`
    display: block;
    button {
      width: 100%;
    }
  `}
  display: inline;

  ${media.phone`
    margin-bottom: 20px;
  `}

  button {
    width: 180px;
    padding: 0;
    &:hover {
      max-width: 200px;
      padding: 0;
    }
  }
`;
